import { render, staticRenderFns } from "./sensor-statistic-popup.vue?vue&type=template&id=022770f5&scoped=true&"
import script from "./sensor-statistic-popup.vue?vue&type=script&lang=js&"
export * from "./sensor-statistic-popup.vue?vue&type=script&lang=js&"
import style0 from "./sensor-statistic-popup.vue?vue&type=style&index=0&id=022770f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022770f5",
  null
  
)

export default component.exports